'use strict';

var d3 = require('d3');
var Chart = function Chart(chartAxes, chartLines, chartParams, chartScales, tooltip, chartHoverOver, chartZoom) {
  return function (container, chartModel, screen, mode) {
    var dispatch = d3.dispatch();
    var svg = d3.select(container[0]).select('svg.main-area');
    var mainAreaSvgBounds = container[0].getBoundingClientRect();
    var axesContainer = d3.select(container[0]).select('svg.axes');
    var axes;
    var lines = chartLines();
    function render() {
      var width = mainAreaSvgBounds.width;
      var height = mainAreaSvgBounds.height;
      var params = chartParams(width, height);
      var scales = chartScales(params, chartModel.getBidPricesList());
      var tip = tooltip(screen + ' ' + mode + ' bid-price-graph');
      var hoverOver = chartHoverOver();
      axes = chartAxes(params);
      var zoom = chartZoom();
      svg.selectAll('.line').remove();
      svg.datum(chartModel.getBidPricesList()).call(lines.scales(scales)).call(axes.scales(scales).chartModel(chartModel).yAxisContainer(axesContainer)).call(tip).call(hoverOver.chartModel(chartModel).scales(scales).tip(tip).chartParams(params)).call(zoom.params(params).scales(scales).toRedraw([axes, lines]));
      svg.selectAll('rect.overlay').remove();
      svg.append('rect').attr('class', 'overlay').attr('width', width).attr('height', height).on('mouseout', function () {
        hoverOver.hideFocus();
        tip.hide() // move invisible tooltip to the left-top corner
        .style({
          top: '0px',
          left: '0px'
        });
      }).on('mousemove', function () {
        var mouseCoordinateX = d3.mouse(this)[0];
        hoverOver.moveFocus(mouseCoordinateX);
      });
    }
    function bindEvents() {
      var stopPropagation = function stopPropagation() {
        d3.event.stopPropagation();
      };
      svg.on('mousedown', stopPropagation);
      svg.on('mouseover', stopPropagation);
      svg.on('mouseout', stopPropagation);
      svg.on('click', stopPropagation);
    }
    var chart = {
      render: render
    };
    bindEvents();
    return d3.rebind(chart, dispatch, 'on');
  };
};
Chart.$inject = ['AVRO.BidPriceGraph.Axis', 'AVRO.BidPriceGraph.Lines', 'AVRO.BidPriceGraph.Params', 'AVRO.BidPriceGraph.Scales', 'AVRO.BidPriceGraph.Tooltip', 'AVRO.BidPriceGraph.HoverOver', 'ChartElementsZoom'];
module.exports = Chart;